/* SHOPYTHON scroll film — frame scrub, finder, reveals.
   Frame locations and count are injected by the section as window.SF_FILM.
   Generated from site/quiet-instrument.html — regenerate, don't hand-edit. */

/* The theme editor re-renders sections without a page load, which would run
   this twice and leave two scroll listeners fighting over the canvas. */
if (window.__sfFilm) { if (window.Shopify && Shopify.designMode) location.reload(); }
else { window.__sfFilm = true;
(function(){
  "use strict";
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var JUMP = new URLSearchParams(location.search).get('jump');
  if (JUMP !== null) history.scrollRestoration = 'manual';

  /* ══════════ FILM: canvas frame scrub ══════════
     Frames are fetched in a sliding window and decoded to ImageBitmap off the
     main thread. Only ~WINDOW frames are ever resident, so a 664-frame film
     costs one frame of load time, not 21 MB up front. */
  var CFG = window.SF_FILM || {};
  var TOTAL = CFG.total || 664, WINDOW = 26, PRELOAD = 6;
  /* Each base is a full URL prefix up to the number, e.g.
     https://cdn.shopify.com/.../files/sf-l-  ->  sf-l-0001.jpg */
  var BASE_L = CFG.landscape || '', BASE_V = CFG.portrait || '';
  var cv = document.getElementById('frames'),
      cvbg = document.getElementById('framesbg'),
      cx = cv.getContext('2d', { alpha:false }),
      cxbg = cvbg.getContext('2d', { alpha:false }),
      film = document.getElementById('film'),
      loading = document.getElementById('floading'),
      ftitle = document.getElementById('ftitle'),
      fcap = document.getElementById('fcap'),
      fcue = document.getElementById('fcue');

  var bmps = new Map(), pending = new Map();   // pending: index -> AbortController|null
  /* Two frame sets: landscape for wide windows, a 9:16 set for phones. The
     vertical set is probed first — if it is missing the page falls straight back
     to the landscape frames in their letterboxed band, so nothing breaks. */
  var DIR = BASE_L, VERT = false;
  var src = function(i){ return DIR + String(i).padStart(4,'0') + '.jpg'; };
  function useVertical(cb){
    if (!BASE_V || !matchMedia('(max-width:760px)').matches) return cb();
    var probe = new Image();
    probe.onload  = function(){ DIR = BASE_V; VERT = true;
      document.documentElement.classList.add('vfilm'); cb(); };
    probe.onerror = function(){ cb(); };
    probe.src = BASE_V + '0001.jpg';
  }
  /* Chrome blocks fetch() on file:// (origin "null"), which would leave the film
     as 664 frames of black if the page is opened by double-clicking it. <img>
     has no such restriction, so that is the fallback. */
  var FILE = location.protocol === 'file:';

  function keep(i, bm){
    pending.delete(i);
    if (Math.abs(i - Math.round(cur)) > WINDOW){ bm.close && bm.close(); return; }
    bmps.set(i, bm);
    // The frame we were waiting on has landed. Repaint — otherwise the canvas
    // stays frozen on whatever nearest frame happened to be resident when the
    // scroll stopped, which can be seconds of film out of date.
    if (!raf) raf = requestAnimationFrame(tick);
  }

  function wantImg(i){                       // <img> path: works on file:// too
    if (i < 1 || i > TOTAL || bmps.has(i) || pending.has(i)) return;
    pending.set(i, null);                    // nothing to abort on this path
    var im = new Image();
    im.decoding = 'async';
    im.onload  = function(){ keep(i, im); };
    im.onerror = function(){ pending.delete(i); };
    im.src = src(i);
  }

  function want(i){
    if (i < 1 || i > TOTAL || bmps.has(i) || pending.has(i)) return;
    if (FILE) return wantImg(i);
    var ac = ('AbortController' in window) ? new AbortController() : null;
    pending.set(i, ac);
    fetch(src(i), ac ? { signal: ac.signal } : undefined)
      .then(function(r){ return r.blob(); })
      .then(function(b){ return createImageBitmap(b); })
      .then(function(bm){ keep(i, bm); })
      .catch(function(e){
        pending.delete(i);
        if (e && e.name === 'AbortError') return;   // we cancelled it on purpose
        wantImg(i);                                 // blocked or failed — try <img>
      });
  }
  function evict(centre){
    bmps.forEach(function(bm, i){
      if (Math.abs(i - centre) > WINDOW){ bm.close && bm.close(); bmps.delete(i); }
    });
    // Abandon fetches for frames we have already scrolled well past, so a jump
    // does not sit behind a backlog of requests for frames nobody will see.
    pending.forEach(function(ac, i){
      if (Math.abs(i - centre) > WINDOW && ac){ ac.abort(); pending.delete(i); }
    });
  }
  function nearest(i){
    if (bmps.has(i)) return bmps.get(i);
    for (var d = 1; d <= WINDOW; d++){
      if (bmps.has(i - d)) return bmps.get(i - d);
      if (bmps.has(i + d)) return bmps.get(i + d);
    }
    return null;
  }
  /* The portrait frames were outpainted, so they extend below the original 16:9
     shot. In the final beat that extra floor fills half the phone screen and the
     croissant reads small — desktop never shows it. Crop back toward the shot so
     both orientations end on the same composition. Ramped, so it never pops. */
  function srcRect(bm, i){
    if (!VERT) return null;
    var a = (i / TOTAL - 0.885) / 0.080;
    a = a < 0 ? 0 : a > 1 ? 1 : a;
    if (!a) return null;
    var keep = 1 - 0.30 * a,
        sh = bm.height * keep,
        sw = sh * (bm.width / bm.height);
    return { sx:(bm.width - sw)/2, sy:(bm.height - sh)*0.12*a, sw:sw, sh:sh };
  }
  function draw(i){
    var bm = nearest(i); if (!bm) return;
    var cw = cv.width, ch = cv.height;
    var r = srcRect(bm, i), iw = r ? r.sw : bm.width, ih = r ? r.sh : bm.height;
    /* Cover-cropping a 16:9 frame into a portrait phone viewport blows it up ~3.5x
       and leaves about a tenth of the composition on screen. On narrow viewports
       fit the width instead and letterbox — the shot stays sharp and legible. */
    var cover = Math.max(cw / iw, ch / ih),
        fit   = Math.min(cw / iw, ch / ih),
        // Fill the panel, unless filling would crop savagely — which only happens
        // when the frame and the window disagree about orientation. Then letterbox
        // and keep the whole composition rather than a blown-up sliver of it.
        s = (cover / fit > 2.2) ? fit : cover,
        w = iw * s, h = ih * s;
    if (h < ch - 1){ cx.fillStyle = '#0B0906'; cx.fillRect(0, 0, cw, ch); }
    if (r) cx.drawImage(bm, r.sx, r.sy, r.sw, r.sh, (cw - w) / 2, (ch - h) / 2, w, h);
    else   cx.drawImage(bm, (cw - w) / 2, (ch - h) / 2, w, h);
    if (bgOn){                                   // tiny canvas, CSS does the blur
      var bw = cvbg.width, bh = cvbg.height,
          bs = Math.max(bw / bm.width, bh / bm.height);
      cxbg.drawImage(bm, (bw - bm.width * bs) / 2, (bh - bm.height * bs) / 2,
                     bm.width * bs, bm.height * bs);
    }
    // dev contract: which frame is actually ON the canvas right now
    window.__frame = bmps.has(i) ? i : nearestIndex(i);
  }
  function nearestIndex(i){
    for (var d = 1; d <= WINDOW; d++){
      if (bmps.has(i - d)) return i - d;
      if (bmps.has(i + d)) return i + d;
    }
    return window.__frame || 0;
  }
  function sizeCanvas(){
    var dpr = Math.min(devicePixelRatio || 1, 2);
    // measure the canvas's own box: on phones it is a 16:9 band, not the panel
    var box = cv.getBoundingClientRect();
    cv.width  = Math.round((box.width  || innerWidth) * dpr);
    cv.height = Math.round((box.height || innerHeight) * dpr);
    bgOn = getComputedStyle(cvbg).display !== 'none';
    if (bgOn){
      var pb = cvbg.getBoundingClientRect();
      cvbg.width  = 64;
      cvbg.height = Math.max(1, Math.round(64 * (pb.height / (pb.width || 1))));
    }
    draw(cur | 0);
  }

  /* ── chapters, keyed to the real clip boundaries in the 41.5s cut ── */
  /* Each beat names the product category doing the work, so the film reads as a
     line of equipment rather than a food ad. Category names only — no brands,
     and no numbers that would need a supplier sheet behind them. */
  var CHAPS = [
    { at:0.000, id:'01', cat:'',                 cap:'' },
    { at:0.113, id:'02', cat:'Whole grain',      cap:'Nothing stripped out yet.' },
    { at:0.227, id:'03', cat:'Stone mills',      cap:'Milled fresh — wholegrain in one pass.' },
    { at:0.352, id:'04', cat:'Spiral mixers',    cap:'Butter, water, salt. Spiral hook, not a paddle.' },
    { at:0.466, id:'05', cat:'Spiral mixers',    cap:'High hydration comes together cool and extensible.' },
    { at:0.603, id:'06', cat:'Dough sheeters',   cap:'Twenty-seven layers, half a millimetre at a time.' },
    { at:0.741, id:'07', cat:'Proofers',         cap:'Shaped by hand. Proved on a schedule you set.' },
    { at:0.879, id:'08', cat:'Convection ovens', cap:'Even heat, with humidity when it counts.' }
  ];
  var lastChap = -1;
  function chapters(p){
    var k = 0;
    for (var i = 0; i < CHAPS.length; i++) if (p >= CHAPS[i].at) k = i;
    if (k === lastChap) return;
    lastChap = k;
    if (CHAPS[k].cap){
      fcap.textContent = '';                       // category label, then the line
      var b = document.createElement('b'); b.textContent = CHAPS[k].cat;
      fcap.appendChild(b);
      fcap.appendChild(document.createTextNode(CHAPS[k].cap));
      fcap.classList.add('on');
    } else fcap.classList.remove('on');
  }

  /* ── rail: croissant browns with the film, not the document ── */
  var fill = document.getElementById('railfill'),
      pct  = document.getElementById('railpct'),
      cro  = document.querySelectorAll('#railcro ellipse');
  var lastLit = -1, lastPct = -1;
  function rail(p){
    fill.style.height = (p * 100).toFixed(1) + '%';
    var w = Math.round(p * 100);
    if (w !== lastPct){ pct.textContent = String(w).padStart(3,'0'); lastPct = w; }
    var lit = Math.round(p * cro.length);
    if (lit !== lastLit){
      cro.forEach(function(e,i){ e.classList.toggle('lit', i < lit); });
      lastLit = lit;
    }
  }

  var cur = 1, target = 1, lastTarget = 1, raf = null, progress = 0, bgOn = false;

  function onScroll(){
    var r = film.getBoundingClientRect();
    var span = film.offsetHeight - innerHeight;
    progress = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
    target = 1 + progress * (TOTAL - 1);
    window.__target = target; window.__progress = progress;

    // title clears out of frame as the film starts moving
    var t = Math.min(1, progress / 0.075);
    ftitle.style.opacity = String(1 - t);
    ftitle.style.transform = 'translateY(' + (-t * 40) + 'px)';
    ftitle.style.pointerEvents = t > 0.6 ? 'none' : 'auto';
    // the scroll cue has done its job by the time the croissant lands
    fcue.style.opacity = String(Math.min(1, Math.max(0, (1 - progress) / 0.08)));
    film.classList.toggle('rolling', progress > 0.02 && progress < 0.99);

    var overFilm = r.top <= 0 && r.bottom > innerHeight * 0.6;
    document.getElementById('hdr').classList.toggle('onfilm', overFilm);
    document.getElementById('hdr').classList.toggle('pinned', !overFilm && scrollY > 80);
    document.body.classList.toggle('past-film', r.bottom <= innerHeight * 0.6);

    chapters(progress); rail(progress);
    if (!raf) raf = requestAnimationFrame(tick);
  }

  function tick(){
    raf = null;
    /* A large delta is a jump, not a scrub — a bookmark, a restored position, a
       hard fling. Snap across it; only smooth genuine scrubbing. */
    if (Math.abs(target - cur) > 50) cur = target;
    else cur += (target - cur) * 0.22;
    if (Math.abs(target - cur) < 0.35) cur = target;
    var i = Math.round(cur), it = Math.round(target);
    /* Fetch around where the scroll is HEADING, not where the canvas is. A smooth-
       scrolled anchor animates the target through every frame in between; filling a
       window at each step queues hundreds that are cancelled before they paint, and
       the frame that matters arrives last. */
    var speed = Math.abs(target - lastTarget); lastTarget = target;
    if (speed > 6){
      // Sweeping: keep barely anything in flight so the landing frame is not queued
      // behind frames the scroll has already passed.
      if (pending.size < 3) want(it);
    } else {
      want(it);
      // Widen to neighbours only once the visible frame has landed, so a 25-frame
      // prefetch never competes with the one frame the viewer is waiting on.
      if (bmps.has(it)) for (var d = -PRELOAD; d <= PRELOAD * 3; d++) want(it + d);
    }
    evict(it);
    draw(i);
    if (Math.abs(target - cur) > 0.05) raf = requestAnimationFrame(tick);
  }

  function startFilm(){
    sizeCanvas();
    addEventListener('scroll', onScroll, { passive:true });
    addEventListener('resize', function(){ sizeCanvas(); onScroll(); });
    onScroll();
    loading.classList.add('gone');
  }


  /* ══════════ page below the film ══════════ */
  var risers = document.querySelectorAll('.rise');
  if (REDUCED || !('IntersectionObserver' in window)) {
    risers.forEach(function(el){ el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin:'0px 0px -10% 0px', threshold:.05 });
    risers.forEach(function(el){ io.observe(el); });
  }

  /* Each route plays its line once the first time it is seen, then releases so
     the cards do not all sit lit. After that, hover is the only trigger. Under
     reduced motion the CSS shows the finished state and nothing runs. */
  if (!REDUCED) {
    var routes = document.querySelectorAll('.route');
    if (routes.length && 'IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (!e.isIntersecting) return;
          var el = e.target; ro.unobserve(el);
          el.classList.add('ran');
          var stages = el.querySelectorAll('.line li').length;
          setTimeout(function(){ el.classList.remove('ran'); }, stages * 340 + 900);
        });
      }, { rootMargin:'0px 0px -12% 0px', threshold:.4 });
      routes.forEach(function(el){ ro.observe(el); });
    }
  }

  var pick = {};
  var LINE = window.SF_LINE || {};
  var WA   = window.SF_WA   || '60178056033';
  var LAST = null;

  /* Prices and URLs are rendered into window.SF_LINE by the section, straight out
     of the store, so this file never carries a figure that can go stale. A slot
     whose handle no longer resolves arrives with p:null; it is listed without a
     price and the total is shown as "from" rather than a number we cannot stand
     behind. Failing towards "ask us" is the safe direction. */
  function slot(id){
    return LINE[id] || { k:'—', n:'Ask us for the current model', p:null, u:null };
  }
  function money(n){ return 'RM ' + Math.round(n).toLocaleString('en-MY'); }

  function build(){
    if (!pick.what || !pick.vol || !pick.mill) return;
    var w = pick.what, v = pick.vol, out = [], notes = [];

    if (w === 'grill'){
      // roasting wants a combi, and nothing upstream of the oven applies
      out.push(slot(v === 's' ? 'roS' : v === 'm' ? 'roM' : 'roL'));
    } else {
      if (pick.mill === 'yes') out.push(slot(v === 'l' ? 'millL' : 'millS'));

      // a spiral hook develops gluten; it cannot cream or whip, so batter goes planetary
      if (w === 'cakes' || w === 'cookies')
        out.push(slot(v === 's' ? 'planS' : v === 'm' ? 'planM' : 'planL'));
      else
        out.push(slot(v === 's' ? 'mixS' : v === 'm' ? 'mixM' : 'mixL'));

      if (w === 'pastry') out.push(slot(v === 's' ? 'shS' : 'shL'));

      var wantsSteam = (w === 'pastry' || w === 'bread');
      out.push(slot(v === 'l' ? 'ovPro'
             : wantsSteam ? (v === 's' ? 'ovHumS' : 'ovHumM')
                          : (v === 's' ? 'ovDryS' : 'ovDryM')));

      if (v === 'l' && wantsSteam)
        notes.push('Past 200 a day the mixer is sized on batch weight, not piece count — send us the dough and we will confirm it.');

      /* Naming the machine that is too much machine is the point of speccing.
         A finder that only ever recommends upward is a price list with buttons. */
      if (v === 's' && wantsSteam)
        notes.push('At under 20 a day the EVO6’s recipe memory and dough probe will not pay for themselves — the IM5-S mixes the same dough. Step up when your batch weight does, not before.');
      if (v === 's' && (w === 'cakes' || w === 'cookies'))
        notes.push('At this volume a bench mixer is the honest answer. Move to a planetary when one batch stops fitting in one bowl.');
    }

    var open = out.some(function(m){ return m.p === null; });
    var sum  = out.reduce(function(a,m){ return a + (m.p || 0); }, 0);
    LAST = { out:out, sum:sum, open:open };

    document.getElementById('result').innerHTML =
      '<span class="rl">Your line — ' + out.length + (out.length === 1 ? ' machine' : ' machines') + '</span><ul>' +
      out.map(function(m){
        var name = m.u ? '<a href="' + m.u + '">' + m.n + '</a>' : m.n;
        return '<li><i>' + m.k + '</i><b>' + name + '</b><span class="num">' +
               (m.p === null ? 'ask us' : money(m.p)) + '</span></li>'; }).join('') +
      '</ul><p class="tot">Indicative ' + (open ? 'from ' : 'total ') + '<b class="num">' +
      money(sum) + '</b> — before trade pricing. ' +
      '<a href="#enquire" style="color:var(--accent)">Ask us to confirm the spec</a>.' +
      notes.map(function(t){ return '<br><span style="color:var(--ink-42)">' + t + '</span>'; }).join('') + '</p>';

    /* hand the answers and the line to the enquiry module, so the customer does
       not retype what they already told the finder */
    if (window.SF_ENQ) {
      window.SF_ENQ.preselect('product', F2E.product[pick.what]);
      window.SF_ENQ.preselect('output',  F2E.output[pick.vol]);
      window.SF_ENQ.setLine(LAST);
    }
  }

  // finder answer -> enquiry chip label, so nobody answers the same question twice
  var F2E = {
    product:{ bread:'Sourdough & bread', pastry:'Croissant & pastry', cakes:'Cake',
              cookies:'Cookies', grill:'Grill & roast' },
    output: { s:'Under 20 a day', m:'20–200 a day', l:'Over 200 a day' }
  };

  /* data-q is the finder, data-eq is the enquiry form. Both use .q/.opts/.opt, so
     these selectors must stay attribute-scoped or one questionnaire writes into
     the other's state. */
  document.querySelectorAll('.q[data-q]').forEach(function(q){
    q.addEventListener('click', function(e){
      var b = e.target.closest('.opt'); if(!b) return;
      q.querySelectorAll('.opt').forEach(function(o){ o.classList.toggle('on', o === b); });
      pick[q.dataset.q] = b.dataset.v; build();
    });
  });


  /* dev contract — __ready must not fire until the frame at the jump position is
     actually decoded and drawn, or the harness screenshots an empty canvas and
     reports a broken page that is merely still loading. */
  function settle(){
    if (JUMP === null){ window.__ready = true; return; }
    scrollTo(0, +JUMP || 0);
    onScroll();
    cur = target;
    var i = Math.round(cur), waited = 0;
    (function awaitFrame(){
      want(i);
      if (bmps.has(i) || waited > 8000){ draw(i); window.__ready = true; return; }
      waited += 100; setTimeout(awaitFrame, 100);
    })();
  }
  /* Everything that fetches a frame lives in here, so it runs only after the
     probe has settled which frame set to use — otherwise frame 1 gets pulled
     from the landscape set and stays cached for the whole session. */
  function boot(){
    if (REDUCED){
      // one still, no scrub, no fetch storm
      var img = new Image();
      img.onload = function(){
        cv.width = img.naturalWidth; cv.height = img.naturalHeight;
        cx.drawImage(img, 0, 0); loading.classList.add('gone');
      };
      img.src = src(TOTAL);
    } else {
      // block only on the first frame, then stream the rest
      fetch(src(1)).then(function(r){ return r.blob(); })
        .then(function(b){ return createImageBitmap(b); })
        .then(function(bm){ bmps.set(1, bm); startFilm(); })
        .catch(startFilm);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ requestAnimationFrame(settle); });
    else addEventListener('load', function(){ requestAnimationFrame(settle); });
  }
  useVertical(boot);
})();
document.addEventListener('shopify:section:load', function(){
  if (window.Shopify && Shopify.designMode) location.reload();
});
}
